// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------------------------------------------
// CABECERA
// ----------------------------------------------------------------------------- */
.expediente .cabecera button {
  border: none;
}
.expediente .cabecera button:hover {
  background-color: black;
}

.expediente .cabecera .comunicaciones,
.expediente .cabecera .botones {
  gap: 10px;
}

.comunicaciones {
  width: 100%;
  justify-content: space-between;
}

.comunicaciones > div {
  gap: 10px;
  align-items: center;
}


.expediente .cabecera .comunicaciones .comunicacion__bloque-derecho button {
  border-radius: 25px;
  padding: 10px 25px;
}

.comunicaciones .comunicacion__bloque-derecho > .boton {
   border-radius: 25px; 
     padding: 10px 25px;
}

.expediente .proxima-cita,
.expediente .cabecera .descargar,
.expediente .cabecera .eliminar {
  padding: 10px 25px;
  gap: 7.5px;
  border-radius: 25px;
  width: auto;
}

.expediente .cabecera .proxima-cita p {
  margin-bottom: 0px;
}

.expediente .cabecera .comunicaciones button {
  border-radius: 50%;
  padding: 10px 15px;
}
expediente .proxima-cita,
.expediente .descargar-expediente .opciones {
  width: 272.5px;
  border: 1px solid #007932;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.expediente .descargar-expediente .opciones button {
  padding: 7.5px 28px;
}

.expediente .descargar-expediente .opciones button:last-child {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.expediente .descargar-expediente .opciones button:hover {
  background-color: #007932;
  color: white;
}

.expediente .cabecera .botones .eliminar {
  background-color: #8e151d;
}
.expediente .cabecera .botones .eliminar:hover {
  background-color: #000;
}

.no-radius {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.ventana-cancelar p {
  line-height: 1.5;
}

.expediente .ventana-cancelar button {
  width: 350px;
  border-radius: 25px;
}

.expediente .ventana-cancelar button:hover {
  background-color: #000;
}

/* -----------------------------------------------------------------------------
// ESTILOS GENERALES PARA LAS CAJAS DEL EXPEDIENTE
// ----------------------------------------------------------------------------- */
.expediente .cv {
  gap: 56px;
  margin-top: 50px;
}

.caja-verde {
  border: 1px solid #007932;
  border-top: 12px solid #007932;
  border-radius: 25px;
}

.expediente h2 {
  font-size: 18px;
  border-top-left-radius: 7.5px;
  border-top-right-radius: 7.5px;
  padding: 0px 15px 8px 20px;
}

.expediente .recomendado h2 {
  padding: 0px 10px 8px 0px;
}

.expediente ul {
  list-style: none;
}

.contenido li {
  border-bottom: 1px solid #007932;
  padding: 7.5px 5px 2.5px 5px;
  flex-wrap: wrap;
}

.expediente .contenido p {
  padding: 7.5px 5px 2.5px 5px;
}

.expediente .contenido.documentos li:last-child,
.expediente .contenido .titulo {
  border-bottom: none;
}

/* -----------------------------------------------------------------------------
// Delete modal
// ----------------------------------------------------------------------------- */
#confirm-delete{
  max-width: 500px;
}

.ct-container {
  max-width: 700px;
  width: 100%;
}

.ct-title {
  display: block;
}

.ct-message {
  margin: 6px 0 12px;
}

.ct-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* Buttons */
.ct-btn {
  border: 0;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font: inherit;
}

.ct-btn:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.6);
  outline-offset: 2px;
}

.ct-btn-cancel {
  background: transparent;
  border: 1px solid currentColor;
  transition: all 0.3s ease-in;
}

.ct-btn-cancel:hover {
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-color: transparent;
    transition: all 0.3s ease-out;
}

.ct-btn-danger {
  background: #8E151D;
  color: #fff;
   transition: all 0.3s ease-in;
}

.ct-btn-danger:hover{
   background: #8E151D;
  opacity: 0.8;
  color: #fff;
  border-color: transparent;
    transition: all 0.3s ease-out;
  filter: brightness(0.95);
}


/* -----------------------------------------------------------------------------
// COLUMNA IZQUIERDA
// ----------------------------------------------------------------------------- */
.expediente .columna-izquierda {
  min-width: 390px;
  max-width: 390px;
  gap: 25px;
}

.expediente .estado-conexion {
  margin-left: 20px;
}
.expediente .estado-conexion p {
  margin-bottom: 0px;
}

/* - Datos personales - */
.expediente .personal {
  border: 1px solid #007932;
  border-bottom: 15px solid #007932;
  padding: 28px 32px 32px 32px;
  border-radius: 28px;
  gap: 20px;
}

element.style {
    font-size: 13px;
    font-style: italic;
    line-height: 1.3;
}

.expediente .personal p {
  margin-bottom: 0px;
}

.expediente .personal .foto-nombre {
  align-items:center;
  gap: 15px;
  margin-bottom: 7.5px;
}

.hidden-input {
  display: none; /* Oculta el input de tipo file */
}

.expediente .personal .foto-perfil {
  width: 100px; /* Ajusta el tamaño según necesites */
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  cursor: default;
}

.expediente .personal .foto-perfil-label {
  display: inline-block;
}

.expediente .personal img {
  width: 90px;
  border-radius: 50%;
}

.expediente .personal .foto-nombre p {
  font-size: 18px;
  line-height: 1.2;
  margin-bottom: 5px;
}

.editar-datos-personales {
  margin-left: 7.5px;
}

.personal .datos-genericos {
  flex-wrap: wrap;
}
.personal .datos-genericos p {
  width: 50%;
}

.expediente .personal .datos-genericos p:last-child {
  text-align: end;
}

.expediente .personal svg {
  font-size: 18px;
}

.check button {
  padding: 5px 6px 0px 6px;
  border-radius: 50%;
  border: none;
}

.curriculum .personal .check button {
  padding: 6px 0px 0px 8px;
}

.check .verde:hover {
  color: #fff;
  background-color: #007932;
}
.check .rojo:hover {
  color: #fff;
  background-color: #8e151d;
}

.estado-conexion .edicion:hover {
  background-color: #fff;
  color: #007932;
}

/* -----------------------------------------------------------------------------
// CAJA NOTAS
// ----------------------------------------------------------------------------- */

.notas {
  border: 1px solid #b90248;
  border-top: 12px solid #b90248;
  border-radius: 25px;
}

.notas h2 {
  background-color: #b90248;
}

.expediente .notas .contenido li {
  margin: 10px 0;
  padding: 10px 15px;
  background-color: #fad3a2;
  border-bottom: none;
  border-radius: 10px;
}

.expediente .notas .botones-nota,
.expediente .notas .botones-editar {
  justify-content: flex-end;
}

.expediente .notas .botones-nota button {
  background-color: transparent;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 4px 6px;
}

.expediente .notas .botones-nota button:hover,
.expediente .botones-editar button:hover,
.expediente .nueva-nota button:hover {
  background-color: #b90248;
}

.expediente .editar-nota textarea,
.expediente .nueva-nota textarea {
  resize: vertical;
  min-height: 60px;
  margin-bottom: 5px;
  background-color: #fad3a2;
}

.expediente .botones-editar button,
.expediente .nueva-nota button {
  margin: 7.5px 5px 1px 0px;
  border: none;
  padding: 5px 20px;
  border-radius: 25px;
  background-color: #fff;
}

.expediente .nueva-nota {
  margin-top: 20px;
}
.expediente .nueva-nota textarea::placeholder {
  color: #000;
}
.expediente .nueva-nota button {
  align-self: flex-end;
}

.expediente .columna-izquierda .contenido {
  padding: 7.5px 15px 15px 15px;
}
.expediente .columna-izquierda .nivel {
  max-width: 150px;
}

/* -----------------------------------------------------------------------------
// COLUMNA DERECHA
// ----------------------------------------------------------------------------- */
.expediente .columna-derecha {
  gap: 25px;
}

.columna-derecha .titulo-editar {
  font-weight: 400;
  padding: 0px 30px 8px 25px;
  border-top-left-radius: 7.5px;
  border-top-right-radius: 7.5px;
}

.columna-derecha h2 {
  gap: 15px;
  font-weight: 400;
  padding: 0px 15px 8px 25px;
}

.columna-derecha .titulo-editar h2 {
  gap: 15px;
  font-weight: 400;
  padding: 0px;
}

.expediente h2 svg {
  font-size: 24px;
  gap: 20px;
}

.columna-derecha .contenido {
  padding: 15px 25px 15px 22.5px;
}
.columna-derecha h2 {
  margin-bottom: 7.5px;
}

.columna-derecha .contenido .competencia {
  width: 550px;
  max-width: 50%;
}

.columna-derecha .contenido .nivel {
  width: 150px;
}

.columna-derecha .iconos {
  width: 68px;
  gap: 10px;
}

/* -- Caja Experiencia laboral-- */
.columna-derecha .ocupaciones .contenido {
  gap: 15px;
}

.columna-derecha .experiencia {
  background-color: #d0fdd7;
  padding: 20px;
  border-radius: 12px;
}

.columna-derecha .cada-experiencia {
  align-items: flex-start;
}
.columna-derecha .experiencia h2 {
  margin-bottom: 0px;
}
.curriculum .contenido p.nivel-cine {
  padding: 2px 5px 2.5px 0px;
}

.columna-derecha .cada-experiencia select {
  margin: 10px 0px;
}

.columna-derecha .cada-experiencia .check {
  padding: 6px 6px 0px 1px;
  border-radius: 50%;
  background-color: #d0fdd7;
}

.columna-derecha .cada-experiencia .check.verde:hover {
  background-color: #007932;
  color: white;
}

.columna-derecha .cada-experiencia .check.rojo:hover {
  background-color: #8e151d;
  color: white;
}

.columna-derecha .experiencia .datos p {
  margin: 0px;
  padding: 0px;
  font-weight: lighter;
}

.columna-derecha .experiencia svg {
  margin-left: 7.5px;
  font-size: 18px;
}

.columna-derecha .contenido .acciones-experiencia {
  width: 52px;
}

.columna-derecha .experiencia .tareas {
  margin-top: 20px;
}

.columna-derecha .experiencia .tareas p {
  margin-bottom: 2.5px;
  padding: 0px;
}

.expediente .columna-derecha .experiencia-edicion,
.curriculum .columna-derecha .experiencia-edicion {
  background-color: #d0fdd7;
  color: black;
}

.columna-derecha .experiencia .datos svg {
  color: #007932;
}

.columna-derecha .experiencia .editar-experiencia:hover,
.personal .editar-datos-personales:hover,
.personal .datos-genericos svg:hover {
  cursor: pointer;
  color: #007932;
}

.columna-derecha .experiencia .eliminar-experiencia:hover {
  color: #8e151d;
}

/* -- Caja Competencias Complementarias-- */
.columna-derecha .nueva-edicion-rapida {
  padding: 15px 25px 15px 22.5px;
}

/* -- Caja Documentos-- */
.expediente .documentos {
  border: none;
}
.expediente .subir-documento:hover {
  cursor: pointer;
}

/* -- Caja Situación Socioeconómica-- */
.expediente .columna-derecha .prestaciones {
  width: 300px;
}
.expediente .columna-derecha .conciliacion {
  width: calc(100% - 500px);
}
.expediente .columna-derecha .vivienda {
  width: 150px;
}

.expediente .columna-derecha .checkbox div {
  width: 175px;
  gap: 5px;
}

.columna-derecha .check {
  gap: 5px;
  margin-bottom: 15px;
}

.expediente .columna-derecha .conciliacion h2 {
  margin-bottom: 0px;
}

.expediente .columna-derecha .conciliacion .checkbox div {
  width: 100%;
}

.expediente .columna-derecha .nueva-seccion {
  border-radius: 25px;
  gap: 10px;
  width: fit-content;
  margin: 0 auto;
  padding: 10px 30px;
  border: 2px solid #007932;
}

.expediente .columna-derecha .nueva-seccion:hover {
  background-color: #000;
  border: 2px solid #000;
}

.expediente .columna-derecha .editar-texto {
  height: 100px;
}

/* -----------------------------------------------------------------------------
// HISTORIAL SEGUIMIENTO
// ----------------------------------------------------------------------------- */
.expediente .historial,
.expediente .recomendado {
  border-radius: 0px;
  border: none;
}

.expediente .titulo-historial {
  border-radius: 0px;
  padding: 12px 28px;
}

.expediente .titulo-historial h2 {
  padding: 0px;
}

.expediente .titulo-historial svg {
  font-size: 20px;
  line-height: 0px;
}

.expediente .historial .ultimo-contacto {
  padding: 25px 25px 20px 25px;
}

.expediente .historial .contenido {
  padding: 0px 25px;
}

.expediente .historial .contenido li {
  gap: 10px 20px;
  padding: 15px 0px;
}

.expediente .historial .fecha {
  width: 90px;
}
.expediente .historial .servicio {
  width: 140px;
}

.expediente .historial .asunto {
  flex: 1 1;
  height: 24px;
  min-height: 30px;
  padding: 2px 15px;
}

.expediente .historial .observaciones {
  flex: 1.5 1;
}

.expediente .historial .editar button,
.editar-cv button {
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 4px 6px;
}

.expediente .historial .editar button:hover,
.editar-cv button:hover,
.botones-docs button:hover {
  color: #007932;
  background-color: #fff;
}

.editar-cv .eliminar:hover,
.eliminar-experiencia:hover {
  color: #8e151d;
}

.expediente .historial textarea {
  width: 100%;
  min-height: 50px;
  resize: vertical;
  border: 1px solid rgb(179, 179, 179);
  padding: 10px 15px;
}

.estrecho {
  padding: 2px 10px;
  border: 1px solid #007932;
  border-radius: 8px;
}

.nueva-edicion-rapida {
  padding: 0px 15px 25px 15px;
}

.curriculum .header,
.expediente .header {
  margin: 5px 15px 0px 12px;
}

.expediente select,
.curriculum select {
  border: none;
  border-bottom: 1px solid #007932;
  outline: none;
}

.botones-guardar-cancelar button,
.botones-acciones button,
.estado-conexion button {
  border: none;
}

.nueva-edicion-rapida button {
  width: 71px;
}

.nueva-edicion-rapida select,
.nueva-edicion-rapida input {
  width: calc(100% - 71px);
}

.curriculum .header,
.expediente .header,
.curriculum .row,
.expediente .row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
}

.contenido .idioma {
  width: 40%;
}

.contenido .nivel {
  width: 30%;
  text-align: left;
}

.contenido .acciones {
  width: 40px;
  text-align: right;
}

.nueva-edicion-rapida {
  align-items: center;
  margin-top: 10px;
}

.competencias .competencia {
  width: 50%;
}

.curriculum input,
.expediente input {
  border-bottom: 1px solid #007932;
}

.competencias .nivel {
  width: 30%;
  text-align: left;
}

.competencias .acciones {
  width: 20%;
  text-align: right;
}

.expediente input::placeholder,
.curriculum input::placeholder {
  color: black;
}

.personal .boton-edicion:hover {
  color: #007932;
}

li.editar-item .check {
  margin-left: auto;
}

.check .disponibilidad:hover {
  background-color: white;
  color: #007932;
}

.personal .datos-genericos .check button:hover svg {
  color: white;
}
.hover-verde:hover {
  color: #007932;
  cursor: pointer;
}

.columna-izquierda .contacto .direccion {
  max-width: 250px;
}

.columna-derecha input.documentos,
.columna-izquierda .editar-competencia,
.editar-habilidad input {
  border: none;
}

/* -----------------------------------------------------------------------------
// AVISO CUANDO EL USUARIO ESTA ACEPTADO PERO NO ACTIVO
// ----------------------------------------------------------------------------- */
.aviso-usuario {
  height: calc(100vh - 300px);
  max-height: 400px;
  border: 2px solid #f4b400;
  border-left: 20px solid #f4b400; /* amarillo */
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  padding: 50px;
  text-align: center;
}

.aviso-usuario .datos-usuario p {
  text-align: left;
}

.aviso-usuario button {
  border: 2px solid #f4b400;
  background-color: #f4b400;
  color: black;
}

.aviso-usuario button:hover {
  border: 2px solid black;
  color: #f4b400;
  background-color: black;
}

.main.expediente .boton.nuevo-usuario {
  border: 2px solid #007932;
}
.main.expediente .boton.nuevo-usuario:hover {
  background-color: #007932;
}

.main.expediente .icono-ojo {
  border: none;
}
.main.expediente .icono-ojo:hover {
  background-color: white;
}
.main.expediente .icono-ojo svg:hover {
  color: #007932;
}

.colectivos .titulo-editar {
  padding-right: 20px;
  border-top-left-radius: 11px;
  border-top-right-radius: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Expediente.css"],"names":[],"mappings":"AAAA;;kFAEkF;AAClF;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;GACG,mBAAmB;KACjB,kBAAkB;AACvB;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;kFAEkF;AAClF;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;kFAEkF;AAClF;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,yBAAyB;IACvB,6BAA6B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;GACV,4BAA4B;AAC/B;;AAEA;GACG,mBAAmB;EACpB,YAAY;EACZ,WAAW;EACX,yBAAyB;IACvB,6BAA6B;EAI/B,wBAAwB;AAH1B;;;AAOA;;kFAEkF;AAClF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB;EACnB,SAAS;AACX;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE,YAAY,EAAE,qCAAqC;EACnD,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;kFAEkF;;AAElF;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;;AAEA;;kFAEkF;AAClF;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;kFAEkF;AAClF;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gCAAgC;EAChC,aAAa;AACf;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;EAIE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;kFAEkF;AAClF;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B,EAAE,aAAa;EAC9C,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B","sourcesContent":["/* -----------------------------------------------------------------------------\n// CABECERA\n// ----------------------------------------------------------------------------- */\n.expediente .cabecera button {\n  border: none;\n}\n.expediente .cabecera button:hover {\n  background-color: black;\n}\n\n.expediente .cabecera .comunicaciones,\n.expediente .cabecera .botones {\n  gap: 10px;\n}\n\n.comunicaciones {\n  width: 100%;\n  justify-content: space-between;\n}\n\n.comunicaciones > div {\n  gap: 10px;\n  align-items: center;\n}\n\n\n.expediente .cabecera .comunicaciones .comunicacion__bloque-derecho button {\n  border-radius: 25px;\n  padding: 10px 25px;\n}\n\n.comunicaciones .comunicacion__bloque-derecho > .boton {\n   border-radius: 25px; \n     padding: 10px 25px;\n}\n\n.expediente .proxima-cita,\n.expediente .cabecera .descargar,\n.expediente .cabecera .eliminar {\n  padding: 10px 25px;\n  gap: 7.5px;\n  border-radius: 25px;\n  width: auto;\n}\n\n.expediente .cabecera .proxima-cita p {\n  margin-bottom: 0px;\n}\n\n.expediente .cabecera .comunicaciones button {\n  border-radius: 50%;\n  padding: 10px 15px;\n}\nexpediente .proxima-cita,\n.expediente .descargar-expediente .opciones {\n  width: 272.5px;\n  border: 1px solid #007932;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n\n.expediente .descargar-expediente .opciones button {\n  padding: 7.5px 28px;\n}\n\n.expediente .descargar-expediente .opciones button:last-child {\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n\n.expediente .descargar-expediente .opciones button:hover {\n  background-color: #007932;\n  color: white;\n}\n\n.expediente .cabecera .botones .eliminar {\n  background-color: #8e151d;\n}\n.expediente .cabecera .botones .eliminar:hover {\n  background-color: #000;\n}\n\n.no-radius {\n  border-bottom-left-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n}\n\n.ventana-cancelar p {\n  line-height: 1.5;\n}\n\n.expediente .ventana-cancelar button {\n  width: 350px;\n  border-radius: 25px;\n}\n\n.expediente .ventana-cancelar button:hover {\n  background-color: #000;\n}\n\n/* -----------------------------------------------------------------------------\n// ESTILOS GENERALES PARA LAS CAJAS DEL EXPEDIENTE\n// ----------------------------------------------------------------------------- */\n.expediente .cv {\n  gap: 56px;\n  margin-top: 50px;\n}\n\n.caja-verde {\n  border: 1px solid #007932;\n  border-top: 12px solid #007932;\n  border-radius: 25px;\n}\n\n.expediente h2 {\n  font-size: 18px;\n  border-top-left-radius: 7.5px;\n  border-top-right-radius: 7.5px;\n  padding: 0px 15px 8px 20px;\n}\n\n.expediente .recomendado h2 {\n  padding: 0px 10px 8px 0px;\n}\n\n.expediente ul {\n  list-style: none;\n}\n\n.contenido li {\n  border-bottom: 1px solid #007932;\n  padding: 7.5px 5px 2.5px 5px;\n  flex-wrap: wrap;\n}\n\n.expediente .contenido p {\n  padding: 7.5px 5px 2.5px 5px;\n}\n\n.expediente .contenido.documentos li:last-child,\n.expediente .contenido .titulo {\n  border-bottom: none;\n}\n\n/* -----------------------------------------------------------------------------\n// Delete modal\n// ----------------------------------------------------------------------------- */\n#confirm-delete{\n  max-width: 500px;\n}\n\n.ct-container {\n  max-width: 700px;\n  width: 100%;\n}\n\n.ct-title {\n  display: block;\n}\n\n.ct-message {\n  margin: 6px 0 12px;\n}\n\n.ct-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n/* Buttons */\n.ct-btn {\n  border: 0;\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font: inherit;\n}\n\n.ct-btn:focus-visible {\n  outline: 2px solid rgba(0, 0, 0, 0.6);\n  outline-offset: 2px;\n}\n\n.ct-btn-cancel {\n  background: transparent;\n  border: 1px solid currentColor;\n  transition: all 0.3s ease-in;\n}\n\n.ct-btn-cancel:hover {\n  background: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  border-color: transparent;\n    transition: all 0.3s ease-out;\n}\n\n.ct-btn-danger {\n  background: #8E151D;\n  color: #fff;\n   transition: all 0.3s ease-in;\n}\n\n.ct-btn-danger:hover{\n   background: #8E151D;\n  opacity: 0.8;\n  color: #fff;\n  border-color: transparent;\n    transition: all 0.3s ease-out;\n}\n\n.ct-btn-danger:hover {\n  filter: brightness(0.95);\n}\n\n\n/* -----------------------------------------------------------------------------\n// COLUMNA IZQUIERDA\n// ----------------------------------------------------------------------------- */\n.expediente .columna-izquierda {\n  min-width: 390px;\n  max-width: 390px;\n  gap: 25px;\n}\n\n.expediente .estado-conexion {\n  margin-left: 20px;\n}\n.expediente .estado-conexion p {\n  margin-bottom: 0px;\n}\n\n/* - Datos personales - */\n.expediente .personal {\n  border: 1px solid #007932;\n  border-bottom: 15px solid #007932;\n  padding: 28px 32px 32px 32px;\n  border-radius: 28px;\n  gap: 20px;\n}\n\nelement.style {\n    font-size: 13px;\n    font-style: italic;\n    line-height: 1.3;\n}\n\n.expediente .personal p {\n  margin-bottom: 0px;\n}\n\n.expediente .personal .foto-nombre {\n  align-items:center;\n  gap: 15px;\n  margin-bottom: 7.5px;\n}\n\n.hidden-input {\n  display: none; /* Oculta el input de tipo file */\n}\n\n.expediente .personal .foto-perfil {\n  width: 100px; /* Ajusta el tamaño según necesites */\n  height: 100px;\n  border-radius: 50%;\n  object-fit: cover;\n  cursor: default;\n}\n\n.expediente .personal .foto-perfil-label {\n  display: inline-block;\n}\n\n.expediente .personal img {\n  width: 90px;\n  border-radius: 50%;\n}\n\n.expediente .personal .foto-nombre p {\n  font-size: 18px;\n  line-height: 1.2;\n  margin-bottom: 5px;\n}\n\n.editar-datos-personales {\n  margin-left: 7.5px;\n}\n\n.personal .datos-genericos {\n  flex-wrap: wrap;\n}\n.personal .datos-genericos p {\n  width: 50%;\n}\n\n.expediente .personal .datos-genericos p:last-child {\n  text-align: end;\n}\n\n.expediente .personal svg {\n  font-size: 18px;\n}\n\n.check button {\n  padding: 5px 6px 0px 6px;\n  border-radius: 50%;\n  border: none;\n}\n\n.curriculum .personal .check button {\n  padding: 6px 0px 0px 8px;\n}\n\n.check .verde:hover {\n  color: #fff;\n  background-color: #007932;\n}\n.check .rojo:hover {\n  color: #fff;\n  background-color: #8e151d;\n}\n\n.estado-conexion .edicion:hover {\n  background-color: #fff;\n  color: #007932;\n}\n\n/* -----------------------------------------------------------------------------\n// CAJA NOTAS\n// ----------------------------------------------------------------------------- */\n\n.notas {\n  border: 1px solid #b90248;\n  border-top: 12px solid #b90248;\n  border-radius: 25px;\n}\n\n.notas h2 {\n  background-color: #b90248;\n}\n\n.expediente .notas .contenido li {\n  margin: 10px 0;\n  padding: 10px 15px;\n  background-color: #fad3a2;\n  border-bottom: none;\n  border-radius: 10px;\n}\n\n.expediente .notas .botones-nota,\n.expediente .notas .botones-editar {\n  justify-content: flex-end;\n}\n\n.expediente .notas .botones-nota button {\n  background-color: transparent;\n  border: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  padding: 4px 6px;\n}\n\n.expediente .notas .botones-nota button:hover,\n.expediente .botones-editar button:hover,\n.expediente .nueva-nota button:hover {\n  background-color: #b90248;\n}\n\n.expediente .editar-nota textarea,\n.expediente .nueva-nota textarea {\n  resize: vertical;\n  min-height: 60px;\n  margin-bottom: 5px;\n  background-color: #fad3a2;\n}\n\n.expediente .botones-editar button,\n.expediente .nueva-nota button {\n  margin: 7.5px 5px 1px 0px;\n  border: none;\n  padding: 5px 20px;\n  border-radius: 25px;\n  background-color: #fff;\n}\n\n.expediente .nueva-nota {\n  margin-top: 20px;\n}\n.expediente .nueva-nota textarea::placeholder {\n  color: #000;\n}\n.expediente .nueva-nota button {\n  align-self: flex-end;\n}\n\n.expediente .columna-izquierda .contenido {\n  padding: 7.5px 15px 15px 15px;\n}\n.expediente .columna-izquierda .nivel {\n  max-width: 150px;\n}\n\n/* -----------------------------------------------------------------------------\n// COLUMNA DERECHA\n// ----------------------------------------------------------------------------- */\n.expediente .columna-derecha {\n  gap: 25px;\n}\n\n.columna-derecha .titulo-editar {\n  font-weight: 400;\n  padding: 0px 30px 8px 25px;\n  border-top-left-radius: 7.5px;\n  border-top-right-radius: 7.5px;\n}\n\n.columna-derecha h2 {\n  gap: 15px;\n  font-weight: 400;\n  padding: 0px 15px 8px 25px;\n}\n\n.columna-derecha .titulo-editar h2 {\n  gap: 15px;\n  font-weight: 400;\n  padding: 0px;\n}\n\n.expediente h2 svg {\n  font-size: 24px;\n  gap: 20px;\n}\n\n.columna-derecha .contenido {\n  padding: 15px 25px 15px 22.5px;\n}\n.columna-derecha h2 {\n  margin-bottom: 7.5px;\n}\n\n.columna-derecha .contenido .competencia {\n  width: 550px;\n  max-width: 50%;\n}\n\n.columna-derecha .contenido .nivel {\n  width: 150px;\n}\n\n.columna-derecha .iconos {\n  width: 68px;\n  gap: 10px;\n}\n\n/* -- Caja Experiencia laboral-- */\n.columna-derecha .ocupaciones .contenido {\n  gap: 15px;\n}\n\n.columna-derecha .experiencia {\n  background-color: #d0fdd7;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.columna-derecha .cada-experiencia {\n  align-items: flex-start;\n}\n.columna-derecha .experiencia h2 {\n  margin-bottom: 0px;\n}\n.curriculum .contenido p.nivel-cine {\n  padding: 2px 5px 2.5px 0px;\n}\n\n.columna-derecha .cada-experiencia select {\n  margin: 10px 0px;\n}\n\n.columna-derecha .cada-experiencia .check {\n  padding: 6px 6px 0px 1px;\n  border-radius: 50%;\n  background-color: #d0fdd7;\n}\n\n.columna-derecha .cada-experiencia .check.verde:hover {\n  background-color: #007932;\n  color: white;\n}\n\n.columna-derecha .cada-experiencia .check.rojo:hover {\n  background-color: #8e151d;\n  color: white;\n}\n\n.columna-derecha .experiencia .datos p {\n  margin: 0px;\n  padding: 0px;\n  font-weight: lighter;\n}\n\n.columna-derecha .experiencia svg {\n  margin-left: 7.5px;\n  font-size: 18px;\n}\n\n.columna-derecha .contenido .acciones-experiencia {\n  width: 52px;\n}\n\n.columna-derecha .experiencia .tareas {\n  margin-top: 20px;\n}\n\n.columna-derecha .experiencia .tareas p {\n  margin-bottom: 2.5px;\n  padding: 0px;\n}\n\n.expediente .columna-derecha .experiencia-edicion,\n.curriculum .columna-derecha .experiencia-edicion {\n  background-color: #d0fdd7;\n  color: black;\n}\n\n.columna-derecha .experiencia .datos svg {\n  color: #007932;\n}\n\n.columna-derecha .experiencia .editar-experiencia:hover,\n.personal .editar-datos-personales:hover,\n.personal .datos-genericos svg:hover {\n  cursor: pointer;\n  color: #007932;\n}\n\n.columna-derecha .experiencia .eliminar-experiencia:hover {\n  color: #8e151d;\n}\n\n/* -- Caja Competencias Complementarias-- */\n.columna-derecha .nueva-edicion-rapida {\n  padding: 15px 25px 15px 22.5px;\n}\n\n/* -- Caja Documentos-- */\n.expediente .documentos {\n  border: none;\n}\n.expediente .subir-documento:hover {\n  cursor: pointer;\n}\n\n/* -- Caja Situación Socioeconómica-- */\n.expediente .columna-derecha .prestaciones {\n  width: 300px;\n}\n.expediente .columna-derecha .conciliacion {\n  width: calc(100% - 500px);\n}\n.expediente .columna-derecha .vivienda {\n  width: 150px;\n}\n\n.expediente .columna-derecha .checkbox div {\n  width: 175px;\n  gap: 5px;\n}\n\n.columna-derecha .check {\n  gap: 5px;\n  margin-bottom: 15px;\n}\n\n.expediente .columna-derecha .conciliacion h2 {\n  margin-bottom: 0px;\n}\n\n.expediente .columna-derecha .conciliacion .checkbox div {\n  width: 100%;\n}\n\n.expediente .columna-derecha .nueva-seccion {\n  border-radius: 25px;\n  gap: 10px;\n  width: fit-content;\n  margin: 0 auto;\n  padding: 10px 30px;\n  border: 2px solid #007932;\n}\n\n.expediente .columna-derecha .nueva-seccion:hover {\n  background-color: #000;\n  border: 2px solid #000;\n}\n\n.expediente .columna-derecha .editar-texto {\n  height: 100px;\n}\n\n/* -----------------------------------------------------------------------------\n// HISTORIAL SEGUIMIENTO\n// ----------------------------------------------------------------------------- */\n.expediente .historial,\n.expediente .recomendado {\n  border-radius: 0px;\n  border: none;\n}\n\n.expediente .titulo-historial {\n  border-radius: 0px;\n  padding: 12px 28px;\n}\n\n.expediente .titulo-historial h2 {\n  padding: 0px;\n}\n\n.expediente .titulo-historial svg {\n  font-size: 20px;\n  line-height: 0px;\n}\n\n.expediente .historial .ultimo-contacto {\n  padding: 25px 25px 20px 25px;\n}\n\n.expediente .historial .contenido {\n  padding: 0px 25px;\n}\n\n.expediente .historial .contenido li {\n  gap: 10px 20px;\n  padding: 15px 0px;\n}\n\n.expediente .historial .fecha {\n  width: 90px;\n}\n.expediente .historial .servicio {\n  width: 140px;\n}\n\n.expediente .historial .asunto {\n  flex: 1;\n  height: 24px;\n  min-height: 30px;\n  padding: 2px 15px;\n}\n\n.expediente .historial .observaciones {\n  flex: 1.5;\n}\n\n.expediente .historial .editar button,\n.editar-cv button {\n  border: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  padding: 4px 6px;\n}\n\n.expediente .historial .editar button:hover,\n.editar-cv button:hover,\n.botones-docs button:hover {\n  color: #007932;\n  background-color: #fff;\n}\n\n.editar-cv .eliminar:hover,\n.eliminar-experiencia:hover {\n  color: #8e151d;\n}\n\n.expediente .historial textarea {\n  width: 100%;\n  min-height: 50px;\n  resize: vertical;\n  border: 1px solid rgb(179, 179, 179);\n  padding: 10px 15px;\n}\n\n.estrecho {\n  padding: 2px 10px;\n  border: 1px solid #007932;\n  border-radius: 8px;\n}\n\n.nueva-edicion-rapida {\n  padding: 0px 15px 25px 15px;\n}\n\n.curriculum .header,\n.expediente .header {\n  margin: 5px 15px 0px 12px;\n}\n\n.expediente select,\n.curriculum select {\n  border: none;\n  border-bottom: 1px solid #007932;\n  outline: none;\n}\n\n.botones-guardar-cancelar button,\n.botones-acciones button,\n.estado-conexion button {\n  border: none;\n}\n\n.nueva-edicion-rapida button {\n  width: 71px;\n}\n\n.nueva-edicion-rapida select,\n.nueva-edicion-rapida input {\n  width: calc(100% - 71px);\n}\n\n.curriculum .header,\n.expediente .header,\n.curriculum .row,\n.expediente .row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 10px;\n}\n\n.contenido .idioma {\n  width: 40%;\n}\n\n.contenido .nivel {\n  width: 30%;\n  text-align: left;\n}\n\n.contenido .acciones {\n  width: 40px;\n  text-align: right;\n}\n\n.nueva-edicion-rapida {\n  align-items: center;\n  margin-top: 10px;\n}\n\n.competencias .competencia {\n  width: 50%;\n}\n\n.curriculum input,\n.expediente input {\n  border-bottom: 1px solid #007932;\n}\n\n.competencias .nivel {\n  width: 30%;\n  text-align: left;\n}\n\n.competencias .acciones {\n  width: 20%;\n  text-align: right;\n}\n\n.expediente input::placeholder,\n.curriculum input::placeholder {\n  color: black;\n}\n\n.personal .boton-edicion:hover {\n  color: #007932;\n}\n\nli.editar-item .check {\n  margin-left: auto;\n}\n\n.check .disponibilidad:hover {\n  background-color: white;\n  color: #007932;\n}\n\n.personal .datos-genericos .check button:hover svg {\n  color: white;\n}\n.hover-verde:hover {\n  color: #007932;\n  cursor: pointer;\n}\n\n.columna-izquierda .contacto .direccion {\n  max-width: 250px;\n}\n\n.columna-derecha input.documentos,\n.columna-izquierda .editar-competencia,\n.editar-habilidad input {\n  border: none;\n}\n\n/* -----------------------------------------------------------------------------\n// AVISO CUANDO EL USUARIO ESTA ACEPTADO PERO NO ACTIVO\n// ----------------------------------------------------------------------------- */\n.aviso-usuario {\n  height: calc(100vh - 300px);\n  max-height: 400px;\n  border: 2px solid #f4b400;\n  border-left: 20px solid #f4b400; /* amarillo */\n  border-radius: 25px;\n  align-items: center;\n  justify-content: center;\n  padding: 50px;\n  text-align: center;\n}\n\n.aviso-usuario .datos-usuario p {\n  text-align: left;\n}\n\n.aviso-usuario button {\n  border: 2px solid #f4b400;\n  background-color: #f4b400;\n  color: black;\n}\n\n.aviso-usuario button:hover {\n  border: 2px solid black;\n  color: #f4b400;\n  background-color: black;\n}\n\n.main.expediente .boton.nuevo-usuario {\n  border: 2px solid #007932;\n}\n.main.expediente .boton.nuevo-usuario:hover {\n  background-color: #007932;\n}\n\n.main.expediente .icono-ojo {\n  border: none;\n}\n.main.expediente .icono-ojo:hover {\n  background-color: white;\n}\n.main.expediente .icono-ojo svg:hover {\n  color: #007932;\n}\n\n.colectivos .titulo-editar {\n  padding-right: 20px;\n  border-top-left-radius: 11px;\n  border-top-right-radius: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
